/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { MasterReportPageAgent, getAgent } from './agent';
const is = require('is_js');

const SERVICE_NAME = 'MasterReportPageService';

@injectable()
export class MasterReportPageService {
  private static instance: MasterReportPageService;
  public agent: MasterReportPageAgent;
  static displayName = 'MasterReportPageService';

  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
